import { createSelector } from "reselect";
import { RootState } from "../../rootReducer";

export const selectCanSign = createSelector(
  [
    (store: RootState) => store.documentSignerShow.signers,
    (store: RootState) => store.documentSignerShow.document,
    (store: RootState) => store.userAuthentication.user,
  ],
  (signers, document, user) => {
    return (
      document.status?.code === "pending" &&
      user?.id === signers.find((signer) => signer.status?.code === "pending")?.stakeholder?.id
    );
  }
);
